import type { ApplicationState } from '../types';

export const selectIsInMigration = (
  state: ApplicationState,
  partnerKey: string
) =>
  Boolean(
    state.supplyMigration?.settings?.integrationKeysToMigrate?.includes(
      partnerKey
    )
  );
